module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main